import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";
import Header from "./Header";
import { AromaDatepickerRecipe } from "@zenchef/styled-system/recipes";
import { Translations } from "./types";
import isFocusedMonth from "./functions/isFocusedMonth";
import isDefaultMonth from "./functions/isDefaultMonth";
import MonthButton from "./MonthButton";

interface Props {
  classes: ReturnType<AromaDatepickerRecipe>;
  translations: Translations;
  defaultValue: ArkUiDatePicker.RootProps["defaultValue"];
  focusedValue: ArkUiDatePicker.RootProps["focusedValue"];
}

export default function MonthView({
  classes,
  translations,
  defaultValue,
  focusedValue,
}: Props) {
  return (
    <ArkUiDatePicker.View view="month" data-view-month className={classes.view}>
      <ArkUiDatePicker.Context>
        {(datePicker) => (
          <>
            <Header
              datePicker={datePicker}
              classes={classes}
              translations={translations}
            />
            <ArkUiDatePicker.Table className={classes.table}>
              <ArkUiDatePicker.TableBody className={classes.body}>
                {datePicker
                  .getMonthsGrid({ columns: 3, format: "long" })
                  .map((months, id) => (
                    <ArkUiDatePicker.TableRow key={id} className={classes.row}>
                      {months.map((month, id) => {
                        const today = new Date();
                        const currentMonth = today.getMonth() + 1;
                        const currentYear = today.getFullYear();

                        const isCurrentMonthInCurrentYear =
                          month.value === currentMonth &&
                          datePicker.focusedValue?.year === currentYear;

                        return (
                          <ArkUiDatePicker.TableCell
                            key={id}
                            value={month.value}
                            className={classes.monthContainer}
                          >
                            <ArkUiDatePicker.TableCellTrigger
                              data-focus-value={
                                isFocusedMonth(month.value, focusedValue) ||
                                undefined
                              }
                              data-default-value={
                                isDefaultMonth(month.value, defaultValue) ||
                                undefined
                              }
                              data-today={
                                isCurrentMonthInCurrentYear || undefined
                              }
                              asChild
                            >
                              <MonthButton month={month.label} />
                            </ArkUiDatePicker.TableCellTrigger>
                          </ArkUiDatePicker.TableCell>
                        );
                      })}
                    </ArkUiDatePicker.TableRow>
                  ))}
              </ArkUiDatePicker.TableBody>
            </ArkUiDatePicker.Table>
          </>
        )}
      </ArkUiDatePicker.Context>
    </ArkUiDatePicker.View>
  );
}
